import React from "react";

const GroupSelect = (props) => {
  const {
    label = "",
    name = "",
    empty = "Select",
    divClass = "input-group",
    labelClass = "",
    options,
    errorMsg,
    children,
    ...extra
  } = props;
  return (
    <li>
      <label className={labelClass}>{label}</label>
      <div className={`select-div ${divClass}`}>
        <select name={name} id={props?.id ?? name} {...extra}>
          <option value="">{empty}</option>
          {options}
        </select>
        {children ?? ""}
        {errorMsg ?? ""}
      </div>
    </li>
  );
};

export default GroupSelect;
